import React from 'react';
import { LightbulbIcon } from 'lucide-react';

interface KeyTakeawayProps {
  children: React.ReactNode;
}

const KeyTakeaway: React.FC<KeyTakeawayProps> = ({ children }) => {
  return (
    <div className="my-8 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 border-l-4 border-blue-500 shadow-sm">
      <div className="flex items-start">
        <div className="flex-shrink-0 bg-blue-100 rounded-full p-2">
          <LightbulbIcon className="h-6 w-6 text-blue-600" />
        </div>
        <div className="ml-4">
          <h3 className="text-lg font-semibold text-blue-800 mb-2">Key Takeaway</h3>
          <div className="text-blue-900">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyTakeaway;